import React from 'react';
import { OrgPlaceholderIcon } from '@pushpay/iconography';
import { Menu } from '@pushpay/menu';
import { add, clsx, createUseStyles } from '@pushpay/styles';
import { useLink } from '../link-provider';
const itemWidthPx = '256px';
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: `${theme.SPACING.SMALL}`,
    width: itemWidthPx,
    borderLeft: `4px solid transparent`
  },
  orgLogo: {
    width: '24px',
    height: '24px',
    marginRight: add(theme.SPACING.XSMALL, theme.SPACING.XXSMALL)
  },
  notSelectedOrg: {
    pointerEvents: 'none'
  },
  orgLink: {
    width: itemWidthPx,
    textDecoration: 'none',
    color: theme.colors['color-text-default'],
    '&:hover, &:focus': {
      textDecoration: 'none'
    },
    '&:focus-visible': {
      outlineOffset: '-1px',
      outline: '1px auto',
      outlineColor: theme.colors['product-color']
    }
  }
}));
export const OrgSwitcherItem = ({
  logoUrl,
  name,
  orgKey,
  linkProps,
  isLoading = false,
  'data-pp-at-target': targetId,
  classes: classesProp,
  className: classNameProp
}) => {
  const classes = useStyles(classesProp);
  const {
    Link
  } = useLink();
  return /*#__PURE__*/React.createElement(Menu.Item, Object.assign({
    key: orgKey,
    component: Link
  }, linkProps, {
    children: null // eslint-disable-line react/no-children-prop
    ,
    role: "menuitem",
    "data-pp-at-target": `${targetId}-${orgKey}-link`,
    className: clsx(classes.orgLink, classNameProp),
    itemValue: orgKey,
    label: name,
    loading: isLoading,
    leftElement: logoUrl ? /*#__PURE__*/React.createElement("img", {
      src: logoUrl,
      className: classes.orgLogo,
      alt: name
    }) : /*#__PURE__*/React.createElement(OrgPlaceholderIcon, {
      "data-pp-at-target": `org-switch-item-placeholder-icon-${name}`,
      className: classes.orgLogo
    })
  }));
};